import { ThemeColors } from '~/themes/colors'

interface SettingsButtonColors {
  Background: {
    Default: ThemeColors
    Hover: ThemeColors
    Alert: ThemeColors
  }
  Border: {
    Default: ThemeColors
    Alert: ThemeColors
  }
}

export const settingsButtonColors: SettingsButtonColors = {
  Background: {
    Default: {
      default: 'gray.100',
    },
    Hover: {
      default: 'gray.400',
    },
    Alert: {
      default: 'red.100',
    },
  },
  Border: {
    Default: {
      default: 'gray.400',
    },
    Alert: {
      default: 'red.600',
    },
  },
}
